<script setup lang="ts">
import type { IProps } from './Table.types'
import type { Block, Text } from '@contentful/rich-text-types'

const props = defineProps<IProps>()
let tableData = props.data.content.map(row =>
  (row as Block).content.map(cell =>
    (cell as Block).content
      .flatMap(p => (p as Block).content)
      .map(t => (t as Text).value)
      .join(' '),
    ),
  )
</script>

<template>
  <div class="articleTable">
    <table
      v-for="row in tableData.slice(1)"
      :key="row[0]"
      class="articleTable__table articleTable__table--mobile"
    >
      <template
        v-for="(item,index) in row"
        :key="item"
      >
        <tr class="articleTable__row">
          <td class="articleTable__header">
            {{ tableData[0]![index] }}
          </td>
        </tr>

        <tr class="articleTable__row">
          <td class="articleTable__data">
            {{  item  }}
          </td>
        </tr>
      </template>
    </table>

    <table
      class="articleTable__table articleTable__table--desktop"
    >
      <tbody>
        <tr
          class="articleTable__row"
        >
          <th
            v-for="item in tableData[0]"
            :key="item"
            class="articleTable__header"
          >
            {{ item }}
          </th>
        </tr>

        <tr
          v-for="(row, index) in tableData.slice(1)"
          :key="index"
          class="articleTable__row"
        >
          <td
            v-for="cell in row"
            :key="cell"
            class="articleTable__data"
          >
            {{ cell }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.articleTable {
  width: 100%;
  margin-bottom: 2.4rem;
  $root: &;

  &__table {
    width: 100%;
    border-collapse: inherit;

    &--desktop {
      display: none;
    }

    &--mobile {
      margin-bottom: 2.4rem;

      #{$root}__row:nth-of-type(even) {
        #{$root}__data  {
          border-bottom: 0;
        }
      }

      #{$root}__row:first-child {
        #{$root}__header {
          border-top-left-radius: 1.6rem;
          border-top-right-radius: 1.6rem;
        }
      }
  
      #{$root}__row:last-child {
        #{$root}__data {
          border-bottom: 1px solid $neutral-300;
          border-bottom-right-radius: 1.6rem;
          border-bottom-left-radius: 1.6rem;
        }
      }
    }
  }

  &__header {
    @include body-2-medium;
    padding: 1.2rem 2.4rem;
    color: $text-400;
    background-color: $gray-100;
    border: 1px solid $neutral-300;
  }

  &__data {
    @include body-2;
    padding: 1.2rem 2.4rem;
    color: $text-400;
    border-right: 1px solid $neutral-300;
    border-bottom: 1px solid $neutral-300;
    border-left: 1px solid $neutral-300;
  }

  @include atS {

    &__table {
      &--mobile {
        display: none;
      }

      &--desktop {
        display: table;

        #{$root}__row:first-child {
          #{$root}__header:nth-of-type(even) {
            border-right: 0;
            border-left: 0;
          }

          #{$root}__header:first-child {
            border-right: 1px solid $neutral-300;
            border-top-left-radius: 1.6rem;
          }

          #{$root}__header:last-child {
            border-right: 1px solid $neutral-300;
            border-top-right-radius: 1.6rem;
          }
        }

        #{$root}__row:last-child {
          #{$root}__data:first-child {
            border-bottom-left-radius: 1.6rem;
          }

          #{$root}__data:last-child {
            border-bottom-right-radius: 1.6rem;
          }

          #{$root}__data {
            border-bottom: 1px solid $neutral-300;
          }
        }

        #{$root}__row {
          #{$root}__data:nth-of-type(even)  {
            border-right: 0;
            border-left: 0;
          }

          #{$root}__data:last-child {
            border-right: 1px solid $neutral-300;
          }
        }
      }
    }
  }
}
</style>
